import { EduContentBookInterface } from './EduContentBook.interface';
import { PersonInterface } from './Person.interface';

export enum PreferenceKey {
  BOOKS = 'FAVORITE_EDUCONTENT_BOOKS',
  SEARCH = 'FILTER_EDUCONTENT',
  TEMPLATE = 'EDUCONTENT_TEMPLATE',
  ALTERNATIVE_PLATFORM_USAGE = 'ALTERNATIVE_PLATFORM_USAGE',
  REMEMBER_LOGIN = 'REMEMBER_LOGIN',
  RECEIVE_MESSAGES = 'RECEIVE_MESSAGES',
  GOALS = 'FILTER_GOALS',
  FILTER_SETS_EDUCONTENT = 'FILTER_SETS_EDUCONTENT',
  VIEW_LIST_AS = 'VIEW_LIST_AS',
  GLOBAL_ASSIGNEE_FILTER = 'GLOBAL_ASSIGNEE_FILTER',
}

export enum ViewListAsEnum {
  LIST = 'list',
  GRID = 'grid',
}

export interface SearchPreferenceValueInterface {
  filters: {
    [field: string]: string | number[];
  };
  columns: { name: string; width?: number; selected: boolean }[];
  sorting: { [name: string]: 'asc' | 'desc' };
  pagination: { from?: number; amount?: number };
}

export interface EduContentBookPreferenceValueInterface {
  favoriteIds: number[];
}

export interface EduContentMetadataTemplateInterface {
  // TODO expand this interface
  eduContentBookId: number;
}

export interface FilterSetPreferenceValueInterface {
  eduContentIds: number[];
}

export interface GlobalAssigneeFilterPreferenceValueInterface {
  groupIds: number[];
  classgroupIds: number[];
  studentIds: number[];
  linkedClassgroupIds?: number[];
  linkedGroupIds?: number[];
}

export type PreferenceValue =
  | SearchPreferenceValueInterface
  | EduContentBookPreferenceValueInterface
  | EduContentMetadataTemplateInterface
  | GlobalAssigneeFilterPreferenceValueInterface
  | FilterSetPreferenceValueInterface
  | any; // Backwards compatibility

export interface PersonPreferenceInterface {
  key: PreferenceKey | string;
  value: PreferenceValue;
  name?: string;
  id?: number;
  personId?: number;
  person?: PersonInterface;
  eduContentBookId?: number;
  eduContentBook?: EduContentBookInterface;
  favoriteBooks?: EduContentBookInterface[];
  isShared?: boolean;
}

// The fields the update-template endpoint accepts. Anything left out stays untouched.
export interface UpdateTemplateInterface {
  name?: string;
  value?: PreferenceValue;
  isShared?: boolean;
  eduContentBookId?: number;
}
